/* -----------------Globals--------------- */
import Icon from "@react-native-vector-icons/material-design-icons/static";
/* -----------------UI--------------- */
import { List } from "react-native-paper";

import { useExamsFilterDialog } from "@contexts/DialogContext/dialogs/exams-filter";
/* -----------------Helpers & Hooks--------------- */
import { useAppTheme } from "@memorang/ui/useAppTheme";

import useExams from "@hooks/useExams";
/* -----------------Child components--------------- */
import ProductIcon from "@memorang/ui/components/ProductIcon";

export const ExamContextListItem = ({
	title,
	icon,
}: {
	title: string;
	icon?: string;
}) => {
	const theme = useAppTheme();

	const { examsList: exams } = useExams();

	const hasMoreThanOneExam = exams.length > 1;

	const { showExamsFilter } = useExamsFilterDialog();

	const handleNavigateToExamsRoute = () => {
		showExamsFilter();
	};

	const leftIcon = () => {
		if (!icon?.includes(".")) {
			return (
				<Icon
					name={
						(icon ?? "file-document-outline") as React.ComponentProps<
							typeof Icon
						>["name"]
					}
					size={24}
					color={theme.colors.onSurfaceVariant}
				/>
			);
		}
		return <ProductIcon image={icon} size={34} />;
	};
	return (
		<List.Item
			style={{
				paddingVertical: 0,
				paddingHorizontal: 16,
			}}
			onPress={hasMoreThanOneExam ? handleNavigateToExamsRoute : undefined}
			title={title}
			right={(p) => {
				return hasMoreThanOneExam ? (
					<List.Icon
						{...p}
						icon={(props) => <Icon {...props} name="swap-horizontal" />}
					/>
				) : null;
			}}
			titleStyle={{
				...theme.typography.fonts.medium,
			}}
			left={leftIcon}
		/>
	);
};
